import { getSintegradaServerApi } from "@/services/api";
import { HospitalWard } from "@/@types/sintegrada/HospitalWard";

export type HospitalWardParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
	departmentId: number;
};

export async function getHospitalWards({ uf, ibgeCode, ...params }: HospitalWardParams) {
	const url = `/Department/hospital-wards`;

	const { data } = await getSintegradaServerApi().get<HospitalWard[]>(url, {
		ibgeCode,
		...params,
	});

	return data || [];
}
